import React from 'react';
import Background from "../../../assets/images/background/banner.jpg";
import "./education.css"
import { Link } from 'react-router-dom';

import Eduimg from "../../../assets/images/Industry Page/education.jpg";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import Faq from "./faq-education";
import Swiper from "../Bfsi Solution/swiper";

import SEO from "../../seo";

export default function Education() {
    const pageKeywords = [
        "react website",
        "static pages",
        "web development",
        "SEO services"
    ]; 
    const CounterOnScroll = ({ end, duration = 2, className }) => {
        const { ref, inView } = useInView({
            triggerOnce: true,
            threshold: 0.3,
        });

        return (
            <span ref={ref}>
                {inView ? (
                    <CountUp end={end} duration={duration} className={className} />
                ) : (
                    <span className={className}>0</span>
                )}
            </span>
        );
    };
    return (
        <div className='product-brand'>
                <SEO
                title="Education"
                description="Industries Take Advantage of Education Software Development We are an education software development company that helps create continuous learning solutions to create seamless learning experiences. Learning Management System (LMS) Details: Implement a robust LMS for course creation, content delivery, student enrollment, and progress tracking. Benefits: Centralized learning hub, enhanced accessibility, and comprehensive student management. Interactive [&hellip;]"
                canonical="https://www.hwplindia.com/industries/education/"
                ogImage="https://www.hwplindia.com/wp-content/uploads/2023/12/industries-education-img.jpg"
                keywords={pageKeywords}
            />
            <section
                className="page-title"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="auto-container">
                    <h2>Education</h2>
                    <ul className="bread-crumb clearfix">
                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li><Link to='/industries'>Industries</Link></li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>Education</li>
                    </ul>
                </div>
            </section>
            <section className='bfsi'>
                <section className="ai-ml-main">
                    <div className='ai-ml-container'>
                        {/* Content Section */}
                        <div className="branding-content">
                            {/* CTA */}
                            <section className="cta-section">
                                <span className='tech'>Industries</span>
                                <h3 className='tech-h3'>Take Advantage of Education Software Development</h3>
                                <p className='email'>
                                    We are an education software development company that helps create continuous learning solutions to create seamless learning experiences.
                                </p>
                            </section>
                            <section className="Industri-section">
                                <div className="industri-card">
                                    <h3 className="indu-title">Learning Management System (LMS)</h3>
                                    <p>
                                        <strong>Details:</strong> Implement a robust LMS for course creation, content delivery, student enrollment, and progress tracking.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Centralized learning hub, enhanced accessibility, and comprehensive student management.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Interactive Course Content</h3>
                                    <p>
                                        <strong>Details:</strong> Create engaging and interactive course materials, including multimedia, quizzes, assignments, and assessments.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Foster student engagement, improve understanding, and cater to various learning styles.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Virtual Classroom and Webinars</h3>
                                    <p>
                                        <strong>Details:</strong> Enable live virtual classrooms, webinars, and collaborative sessions for real-time interaction.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Facilitate remote learning, encourage participation, and provide a dynamic learning experience.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Student and Faculty Portals</h3>
                                    <p>
                                        <strong>Details:</strong> Develop dedicated portals for students and faculty to access courses, assignments, grades, and communication tools.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Personalized user experiences, streamlined communication, and easy information access.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Assessment and Grading Tools</h3>
                                    <p>
                                        <strong>Details:</strong> Incorporate tools for creating, administering, and grading quizzes, exams, and assignments.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Efficient assessment processes, timely feedback, and accurate grading.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Learning Analytics and Reporting</h3>
                                    <p>
                                        <strong>Details:</strong> Implement analytics tools to track student performance, engagement, and learning outcomes.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Data-driven insights, continuous improvement, and personalized learning recommendations.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Collaborative Learning Features</h3>
                                    <p>
                                        <strong>Details:</strong> Enable collaborative tools such as discussion forums, group projects, and peer-to-peer learning.  
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Encourage teamwork, enhance communication, and promote a collaborative learning environment. 
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Mobile Learning (M-Learning)</h3>
                                    <p>
                                        <strong>Details:</strong> Ensure compatibility with mobile devices for on-the-go learning experiences.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Accessibility, flexibility, and the ability to reach learners anytime, anywhere.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Integration with Learning Resources:</h3>
                                    <p>
                                        <strong>Details:</strong> Integrate seamlessly with external learning resources, libraries, and educational databases.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong>  Expanded content access, diverse learning materials, and enriched educational experiences.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Gamification Elements</h3>
                                    <p>
                                        <strong>Details:</strong> Incorporate gamified elements such as badges, rewards, and leaderboards to enhance engagement.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong>  Motivate learners, increase participation, and create an enjoyable learning environment.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Secure Authentication and Authorization</h3>
                                    <p>
                                        <strong>Details:</strong>  Implement secure login processes, role-based access controls, and data encryption.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Protect sensitive information, ensure user privacy, and maintain data integrity.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Communication and Notifications</h3>
                                    <p>
                                        <strong>Details:</strong> Include communication channels like messaging, announcements, and notifications to keep students and faculty informed.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Improved communication, timely updates, and enhanced collaboration.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Adaptive Learning Paths</h3>
                                    <p>
                                        <strong>Details:</strong> Offer personalized learning paths based on individual student progress and performance.   
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Tailored learning experiences, targeted interventions, and improved learning outcomes.
                                    </p>
                                </div>

                                <div className="industri-card">
                                    <h3 className="indu-title">Multilingual Support</h3>
                                    <p>
                                        <strong>Details:</strong> Provide support for multiple languages to cater to a diverse student population.
                                    </p>
                                    <p>
                                        <strong>Benefits:</strong> Inclusivity, accessibility, and the ability to reach a global audience.
                                    </p>
                                </div>
                            </section>
                        </div>
                    </div>
                    <section className='bfsi-clor'>
                        <section class="bfsi-section">
                            <div class="bfsi-grid">
                                <div class="bfsi-left">
                                    <h2>
                                        Meet Best Education Software  
                                        Development Company
                                    </h2>

                                    <p>
                                        Support learning and development with our customized software solutions for educational development. At Horizon Webinfo Pvt. Ltd. we are committed to transforming the way information is given and received. Our commitment is to create intuitive, scalable and interactive software solutions that meet the needs of diverse learning environments and create quality learning experiences.
                                    </p>

                                    <div class="bfsi-stats">
                                        <div className="stat-box">
                                            <h3>
                                                <CounterOnScroll end={20} duration={2} className="counter" /> +
                                            </h3>
                                            <span>Years Of Experience</span>
                                        </div>

                                        <div className="stat-box">
                                            <h3>
                                                <CounterOnScroll end={5000} duration={3} className="counter" /> +
                                            </h3>
                                            <span>Happy Customers</span>
                                        </div>

                                    </div>
                                    <span className='elementor-divider-separator'></span>
                                </div>

                                <div class="bfsi-right">
                                    <div class="red-shape"></div>
                                    <img src={Eduimg} class="bfsi-img" />
                                </div>
                            </div>
                        </section>
                    </section>

                    <Faq />
                    <Swiper />

                </section>
            </section>
        </div>
    );
}